
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5239',
  depVersions: {
  "data-privacy-request-ui": "static-1.5239",
  "data-fetching-client": "static-1.9390",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7697",
  "hub-http-shared-msw-handlers": "static-1.9249",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11138",
  "I18n": "static-7.1546",
  "jasmine-runner": "static-1.6169",
  "privacy-center-public-service-types": "static-1.4502",
  "quartz": "static-1.6600",
  "react-dlb": "static-1.70",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5276",
  "UIComponents": "static-3.8085",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.80",
  "foundations-assets": "static-1.4546",
  "foundations-components": "static-1.7343",
  "foundations-components-test-utils": "static-1.4826",
  "foundations-theming": "static-1.4118",
  "hub-http": "static-1.5872",
  "quartz-config": "static-1.378",
  "quartz-core": "static-1.5819",
  "quick-fetch": "static-1.3650",
  "raven": "static-3.5624",
  "react": "static-7.176",
  "react-rhumb": "static-1.16346",
  "SharedI18nStrings": "static-1.179",
  "ui-addon-i18n": "static-1.10842",
  "usage-tracker": "static-1.7049",
  "usage-tracker-anonymous": "static-1.5466",
  "usage-tracker-core": "static-1.6899",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3873",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9346",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3150",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2877",
  "quartz-webpack": "static-1.2824",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "HeadJS": "static-2.694",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2808",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3826",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "react-utils": "static-2.5098",
  "StyleGuideUI": "static-3.482",
  "jasmine": "static-4.4045",
  "rpc-client-utils": "static-1.4321",
  "HubStyle": "static-2.11446",
  "ui-addon-draggable": "static-3.4458",
  "cssUtils": "static-1.705",
  "hs-story-utils": "static-1.9140",
  "icons": "static-2.615",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1066",
  "bend-plugin-foundations-components": "static-1.3612",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1834",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.999",
  "ui-fonts": "static-1.400",
  "bend-plugin-foundations-theming": "static-1.2601",
  "foundations-theming-base": "static-1.3103",
  "stylex": "static-1.26",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.775",
  "hubspotter-http": "static-1.4400",
  "mobile-manifest-mixins": "static-1.467",
  "quartz-auth": "static-1.275",
  "quartz-head": "static-1.265",
  "quartz-i18n": "static-1.275",
  "quartz-routing": "static-1.30",
  "quartz-test": "static-1.275",
  "usage-tracker-container": "static-1.7039",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2832",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.64",
  "sassPrefix": "static-1.150",
  "hubspotter-http-shared-msw-handlers": "static-1.9247"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5239",
  "data-fetching-client": "/data-fetching-client/static-1.9390",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7697",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9249",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11138",
  "I18n": "/I18n/static-7.1546",
  "jasmine-runner": "/jasmine-runner/static-1.6169",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4502",
  "quartz": "/quartz/static-1.6600",
  "react-dlb": "/react-dlb/static-1.70",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5276",
  "UIComponents": "/UIComponents/static-3.8085",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "foundations-assets": "/foundations-assets/static-1.4546",
  "foundations-components": "/foundations-components/static-1.7343",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4826",
  "foundations-theming": "/foundations-theming/static-1.4118",
  "hub-http": "/hub-http/static-1.5872",
  "quartz-config": "/quartz-config/static-1.378",
  "quartz-core": "/quartz-core/static-1.5819",
  "quick-fetch": "/quick-fetch/static-1.3650",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.176",
  "react-rhumb": "/react-rhumb/static-1.16346",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10842",
  "usage-tracker": "/usage-tracker/static-1.7049",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5466",
  "usage-tracker-core": "/usage-tracker-core/static-1.6899",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9346",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3150",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2877",
  "quartz-webpack": "/quartz-webpack/static-1.2824",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "HeadJS": "/HeadJS/static-2.694",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2808",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3826",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "react-utils": "/react-utils/static-2.5098",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "jasmine": "/jasmine/static-4.4045",
  "rpc-client-utils": "/rpc-client-utils/static-1.4321",
  "HubStyle": "/HubStyle/static-2.11446",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4458",
  "cssUtils": "/cssUtils/static-1.705",
  "hs-story-utils": "/hs-story-utils/static-1.9140",
  "icons": "/icons/static-2.615",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1066",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3612",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1834",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.999",
  "ui-fonts": "/ui-fonts/static-1.400",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2601",
  "foundations-theming-base": "/foundations-theming-base/static-1.3103",
  "stylex": "/stylex/static-1.26",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.775",
  "hubspotter-http": "/hubspotter-http/static-1.4400",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.467",
  "quartz-auth": "/quartz-auth/static-1.275",
  "quartz-head": "/quartz-head/static-1.265",
  "quartz-i18n": "/quartz-i18n/static-1.275",
  "quartz-routing": "/quartz-routing/static-1.30",
  "quartz-test": "/quartz-test/static-1.275",
  "usage-tracker-container": "/usage-tracker-container/static-1.7039",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2832",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.64",
  "sassPrefix": "/sassPrefix/static-1.150",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9247"
}
};
